module.exports = __webpack_public_path__ + "static/media/arrival-icon.83b2a32a.svg";